import React from 'react'
import { NavLink } from "react-router-dom";
import { routerPath } from '../../navigation/path';

const Sidebar = () => {
    return (
        <div className="w-[18rem] bg-[#0A142F] text-white">
            <nav>
                <ul className="list-none p-0">
                    <li className="py-3 px-5">
                        <NavLink
                            to={routerPath.myAccount}
                            className={({ isActive }) =>
                                `${isActive ? "font-bold text-blue-500" : "text-white"} no-underline`
                            }
                        >
                            Dashboard
                        </NavLink>
                    </li>
                    <li className="py-3 px-5">
                        <NavLink
                            to={routerPath.orders}
                            className={({ isActive }) =>
                                `${isActive ? "font-bold text-blue-500" : "text-white"} no-underline`
                            }
                        >
                            Orders
                        </NavLink>
                    </li>
                    <li className="py-3 px-5">
                        <NavLink
                            to={routerPath.savings}
                            className={({ isActive }) =>
                                `${isActive ? "font-bold text-blue-500" : "text-white"} no-underline`
                            }
                        >
                            Your Savings
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar  